

















import { Vue, Component } from 'vue-property-decorator';
import SearchBar from '@/components/next/SearchBar.vue';
import VoteList from '../components/VoteList.vue';
@Component({
  components: {
    SearchBar,
    VoteList,
  },
})
export default class Home extends Vue {
  // activeType = '1';
  // searchText = '请输入姓名（以姓氏笔画排序）';
  // tab = [
  //   { text: '2023十大重庆科技创新年度人物', id: '1' },
  //   { text: '2023十大重庆科技创新年度企业家', id: '2' },
  //   { text: '2023西部（重庆）科学城十大科技创新服务机构', id: '3' },
  // ];
  // search = '';
  // changeTab(item: any) {
  //   this.activeType = item.id;
  //   if (this.activeType === '1') {
  //     this.searchText = '请输入姓名（以姓氏笔画排序）';
  //   } else if (this.activeType === '2') {
  //     this.searchText = '请输入姓名（以姓氏笔画排序）';
  //   } else {
  //     this.searchText = '请输入事件（以首字笔画排序）';
  //   }
  // }
}
